import { render, staticRenderFns } from "./accountIpPage.vue?vue&type=template&id=081bfd15&scoped=true&"
import script from "./accountIpPage.vue?vue&type=script&lang=js&"
export * from "./accountIpPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081bfd15",
  null
  
)

export default component.exports